module.exports = __webpack_public_path__ + "img/bg-banner.9cd3672c.png";